import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {SearchSpan,TableIcon} from '../../../common/Global/globalStyles.style';
import FilterDropDown from '../../../common/DropdownMenus/FilterDropdown';
import Pagination from '../../../common/Global/pagination';
import {getLocalStorageVariables,isEmptyVariable,sortTable,truncateString,
    isEmptyArray,ifEmptyReturnEmptyStr,
    hasFeatureAccess,
    handleTokenExpiry} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import DocumentSamplesListLayout from './listDocumentSample';
import DocumentERPListLayout from './listDocumentERPMaster';

let userDetails = getLocalStorageVariables();
const sortShortName = "d.shortName";
const sortName = "d.name";
const sortDescription = "d.description";

class DocumentSampleList extends Component{
    constructor(props){
        super(props);
        this.state = {
            componentDidMountFlag:false,
            apiSearchKey:"",
            searchkey:"",
            currentPageNo: 1,
            showLoader:false,
            resultSize:Constants.RESULT_SIZE,
            totalCount:0,
            datalist:[],
            resultSizePlaceholder:Constants.RESULT_SIZE,
            resultSizeArr:Constants.RESULT_SIZE_DD_ARR,
            sort:"",
            sortDir:"",

            showDocumentListing:true,
            showDocumentSamplesListing:false,
            showDocumentERPListing:false,
            selectedDocumentId:"",
            selectedDocumentName:"",

            showDetailsDialog:false,
            selectedItem:"",
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showDocumentDialog){
            this.setState({
                componentDidMountFlag:false,
                apiSearchKey:"",
                searchkey:"",
                currentPageNo: 1,
                showLoader:false,
                resultSize:Constants.RESULT_SIZE,
                totalCount:0,
                datalist:[],
                resultSizePlaceholder:Constants.RESULT_SIZE,
                resultSizeArr:Constants.RESULT_SIZE_DD_ARR,
                sort:"",
                sortDir:"",

                showDocumentListing:true,
                showDocumentSamplesListing:false,
                showDocumentERPListing:false,
                selectedDocumentId:"",
                selectedDocumentName:"",


                showDetailsDialog:false,
                selectedItem:"",
            },()=>{
                this.getDocumentList();
            })
            
        }
    }

    handleChangeSearch = (e) => {
        const { name, value } = e.target;

        this.setState({ 
            [name]: value
        });
    }

    onSearchIconClick = () => {
        this.setState({
            currentPageNo:1
        },()=>{
            this.getDocumentList();
        })
    }

    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.setState({
                currentPageNo:1
            },()=>{
                this.getDocumentList();
            })
        }
    }

    resultSizeDropdownClick = (item,selectedIndex) => {
        let tempArr = this.state.resultSizeArr;
        let placeholder = "";

        for(const [i,value] of tempArr.entries()){
            if(i === selectedIndex){
                tempArr[i].isSelected = true;
                placeholder = value.label ;
            }else{
                tempArr[i].isSelected = false;
            }
        }
        
        this.setState({
            resultSizeArr:tempArr,
            resultSize:item.label,
            resultSizePlaceholder:placeholder
        },() => {
            this.getDocumentList();
        })
    }

    handleShowDocumentSamplesListing = (document,e) => {
        e.stopPropagation();
        this.setState({
            selectedDocumentId:document.documentId,
            selectedDocumentName:document.name,
            showDocumentListing:false,
            showDocumentSamplesListing:true,
            showDocumentERPListing:false,
        })
    }

    handleShowDocumentERPListing = (document,e) => {
        e.stopPropagation();
        this.setState({
            selectedDocumentId:document.documentId,
            selectedDocumentName:document.name,
            showDocumentListing:false,
            showDocumentSamplesListing:false,
            showDocumentERPListing:true,
        })
    }

    handleBackBtnClickFromSamplesandERP = () => {
        this.setState({
            selectedDocumentId:"",
            selectedDocumentName:"",
            showDocumentListing:true,
            showDocumentSamplesListing:false,
            showDocumentERPListing:false,
        })
    }

    handleDetailsDialogClose = () =>{
        this.setState({
            showDetailsDialog:false,
            selectedItem:"",
        });
    }

    handleDetailsDialogShow = (item) => {
        this.setState({
            showDetailsDialog:true,
            selectedItem:item,
        });
    }

    sortTableLocal = (sortColumn) => {
        let sortObj = sortTable(sortColumn,this.state.sort,this.state.sortDir);

        this.setState({
            sort:sortObj.sortTemp,
            sortDir:sortObj.sortDirTemp,
        },()=>{
            this.getDocumentList();
        })
    }

    /*****************************API*********************************/
    getDocumentList = () => {
        this.setState({
            showLoader:true,
        });

        let url = "";
        let postParam = {
            email:userDetails.email,
            accessToken:userDetails.accessToken,
            taskId:this.props.taskId,
            pageNo:this.state.currentPageNo,
            search:this.state.searchkey,
            resultsize:this.state.resultSize,
            sort:this.state.sort,
            sortDir:this.state.sortDir,
        }
        if(this.props.isDraftOnward === true){
            url = Constants.GetDraftTaskDocuments;
            postParam.forDraft = true;
        }else{
            url = Constants.GetTaskDocuments;
        }

        fetch(url,
        {
            method:"POST",
            mode:"cors",
            body: new URLSearchParams(postParam)
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    componentDidMountFlag:true,
                    datalist:data.data.result,
                    totalCount:data.data.count,
                    apiSearchKey:this.state.searchkey,
                });
            }else{
                this.setState({
                    showLoader:false,
                    componentDidMountFlag:true,
                    datalist:[],
                    totalCount:0,
                    apiSearchKey:this.state.searchkey,
                });
            }
        });
    }

    onChangePage = (page) => {
        // update state with new page of items
        if(page !== this.state.currentPageNo){
            this.setState({
                showLoader:true,
            });

            let url = "";
            let postParam = {
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                taskId:this.props.taskId,
                pageNo:page,
                search:this.state.searchkey,
                resultsize:this.state.resultSize,
                sort:this.state.sort,
                sortDir:this.state.sortDir,
            }
            if(this.props.isDraftOnward === true){
                url = Constants.GetDraftTaskDocuments;
                postParam.forDraft = true;
            }else{
                url = Constants.GetTaskDocuments;
            }

            fetch(url,
            {
                method:"POST",
                mode:"cors",
                body: new URLSearchParams(postParam)
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        showLoader:false,
                        componentDidMountFlag:true,
                        datalist:data.data.result,
                        totalCount:data.data.count,
                        apiSearchKey:this.state.searchkey,
                        currentPageNo:page,
                    });
                }else{
                    this.setState({
                        showLoader:false,
                        componentDidMountFlag:true,
                        datalist:[],
                        totalCount:0,
                        apiSearchKey:this.state.searchkey,
                    });
                }
            });
        }
    }

    render(){
        return(
            <section>
                <Modal className="task-select-table-dialog custom-dialog"
                    show={this.props.showDocumentDialog} 
                    onHide={this.props.handleSelectDocDialogClose}>
                    <Modal.Header>
                        <h5>Documents</h5>
                        <button 
                            onClick={this.props.handleSelectDocDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        {
                            this.state.showLoader &&
                            <div class="loader"></div>
                        }
                        {
                            // Need to check component did mount flag, other wise until api is called,
                            // it shows no items found layout.
                            this.state.showDocumentListing &&
                            this.state.componentDidMountFlag &&
                            <div className="body-wrapper">
                                <div className="search-addnew-bg" style={{marginTop:0}}>
                                    <div className="search-addnew">
                                        
                                        <div className="search-filter-layout">
                                            <FilterDropDown
                                                placeholder={this.state.resultSizePlaceholder}
                                                dropdownArr={this.state.resultSizeArr}
                                                onDropDownItemClick={this.resultSizeDropdownClick}
                                                addBorder={true}
                                                themeSettings={this.props.themeSettings}
                                                mleft={0}
                                            />
                                            <div className="search-col m-l-10" style={{border:"1px solid #e5e5e5"}}>
                                                <input 
                                                    name="searchkey" 
                                                    type="text"
                                                    onChange={this.handleChangeSearch}
                                                    placeholder="Search" 
                                                    onKeyPress={this.onEnterBtnPress}
                                                    value={this.state.searchkey}
                                                />
                                                <SearchSpan 
                                                themeSettings={this.props.themeSettings}
                                                onClick = {this.onSearchIconClick} className="material-icons"> search </SearchSpan>
                                            </div>

                                            
                                        </div>
                                    </div>
                                </div>

                                {
                                    !isEmptyArray(this.state.datalist) && 
                                    <div className="common-tab-bg">
                                        <div className="common-table" style={{width:"100%",border:"1px solid #e5e5e5"}}>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center" width={"5%"}>No</th>
                                                        <th  className="c-pointer" onClick={this.sortTableLocal.bind(this,sortShortName)}>
                                                            <div className="sort-header">Short Name
                                                            <span className={(this.state.sort === sortShortName)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                            </div>
                                                        </th>
                                                        <th width={"25%"} className="c-pointer" onClick={this.sortTableLocal.bind(this,sortName)}>
                                                            <div className="sort-header">Name
                                                            <span className={(this.state.sort === sortName)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                            </div>
                                                        </th>
                                                        <th width={"25%"} className="c-pointer" onClick={this.sortTableLocal.bind(this,sortDescription)}>
                                                            <div className="sort-header">Description
                                                            <span className={(this.state.sort === sortDescription)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                            </div>
                                                        </th>
                                                        {hasFeatureAccess(Constants.FEATURE_DOCUMENT_ERP) &&
                                                            <th className="text-center"  width={"5%"}>ERP</th>
                                                        }
                                                        {hasFeatureAccess(Constants.FEATURE_DOCUMENT_SAMPLES) &&
                                                            <th className="text-center"  width={"10%"}>Samples</th>
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    !isEmptyArray(this.state.datalist) && 
                                                    this.state.datalist.map((item,idx) => {

                                                        return <tr onClick={this.handleDetailsDialogShow.bind(this,item)}>
                                                            <td className="text-center">{((this.state.currentPageNo - 1) * this.state.resultSize) + (++idx)}</td>
                                                            <td>{item.shortName}</td>
                                                            <td>{item.name}</td>
                                                            <td>{truncateString(item.description,Constants.OTHERMASTERS_STRING_LENGTH)}</td>
                                                            {hasFeatureAccess(Constants.FEATURE_DOCUMENT_ERP) &&
                                                                <TableIcon 
                                                                themeSettings={this.props.themeSettings} className="text-center">
                                                                    <span class="material-icons" onClick={this.handleShowDocumentERPListing.bind(this, item)}>visibility</span>
                                                                </TableIcon>
                                                            }
                                                            {hasFeatureAccess(Constants.FEATURE_DOCUMENT_SAMPLES) &&
                                                                <TableIcon 
                                                                    themeSettings={this.props.themeSettings} className="text-center">
                                                                    <span class="material-icons" onClick={this.handleShowDocumentSamplesListing.bind(this, item)}>topic</span>
                                                                </TableIcon>
                                                            }
                                                        </tr>
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) &&
                                    <div class="no-items-layout">
                                        <div class="no-items-card">
                                            <h6>
                                            {
                                                isEmptyVariable(this.state.apiSearchKey)?
                                                Constants.NO_RECORDS_WARNING
                                                :
                                                Constants.EMPTY_SEARCH_WARNING
                                            }
                                            </h6>
                                        </div>
                                    </div>
                                }
                                <div className="pagination-layout">
                                    <div className="row custom-row">
                                        <div className="col-md-9 custom-col">
                                        {
                                            (this.state.totalCount > this.state.datalist.length) && 
                                            <Pagination 
                                                totalLength ={this.state.totalCount} 
                                                items={this.state.datalist} 
                                                onChangePage={this.onChangePage} 
                                                pageSize={this.state.resultSize}
                                                currentPageNo = {this.state.currentPageNo}
                                                initialPage={this.state.currentPageNo}
                                                themeSettings={this.props.themeSettings} />
                                        }
                                        </div>
                                        <div className="col-md-3 custom-col">
                                            <p>{"Total Records: "+this.state.totalCount}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            this.state.showDocumentSamplesListing &&
                            <DocumentSamplesListLayout
                                documentId={this.state.selectedDocumentId}
                                documentName={this.state.selectedDocumentName}
                                handleBackBtnClickFromSamplesandERP={this.handleBackBtnClickFromSamplesandERP}
                                themeSettings={this.props.themeSettings}
                                isDraftOnward={this.props.isDraftOnward}
                                assignmentId={this.props.assignmentId}
                            />
                        }
                        {
                            this.state.showDocumentERPListing &&
                            <DocumentERPListLayout
                                documentId={this.state.selectedDocumentId}
                                documentName={this.state.selectedDocumentName}
                                handleBackBtnClickFromSamplesandERP={this.handleBackBtnClickFromSamplesandERP}
                                themeSettings={this.props.themeSettings}
                                isDraftOnward={this.props.isDraftOnward}
                                assignmentId={this.props.assignmentId}
                            />
                        }
                    </div>
                </Modal>

                <Modal className="custom-dialog" show={this.state.showDetailsDialog} onHide={this.handleDetailsDialogClose}>
                    <Modal.Header>
                        <h5>{this.state.selectedItem.shortName}</h5>
                        <button 
                            onClick={this.handleDetailsDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div class="modal-body">
                        <div className="details-table-layout">
                            <div className="row custom-row">
                                <div className="col-md-12 custom-col">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={"24%"}>Short Name</td>
                                                <td width={"4%"}>:</td>
                                                <td width={"72%"}>{this.state.selectedItem.shortName}</td>
                                            </tr>
                                            <tr>
                                                <td width={"24%"}>Name</td>
                                                <td width={"4%"}>:</td>
                                                <td width={"72%"}>{this.state.selectedItem.name}</td>
                                            </tr>
                                            <tr>
                                                <td width={"24%"}>Function</td>
                                                <td width={"4%"}>:</td>
                                                <td width={"72%"}>{this.state.selectedItem.functionName}</td>
                                            </tr>
                                            <tr>
                                                <td width={"24%"}>Description</td>
                                                <td width={"4%"}>:</td>
                                                <td width={"72%"}>{ifEmptyReturnEmptyStr(this.state.selectedItem.description,"-")}</td>
                                            </tr>
                                            <tr>
                                                <td width={"24%"}>Department</td>
                                                <td width={"4%"}>:</td>
                                                <td width={"72%"}>{this.state.selectedItem.departmentName}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </section>
        )
    }
}

export default DocumentSampleList;